var WDN = WDN || {};

if (typeof WDN.ProductSignup === "undefined") {
  WDN.ProductSignup = (function () {
    var init, bind;
    var containerVisible, inputError;
    var setVariantInputValue;
    var updateDescription;
    var updateRestockMessage;

    // Handlers
    var onVariantChange, onDummyCheckboxChange, onDummyEmailKeyup;
    var onDummySubmit, onFormStatusEvent;

    // Config dump in the snippet - contains translation keys and some product details
    var config = WDN.ProductSignupConfig || {};

    var _selectedVariant = false;

    // Nodes
    var nodes = {
      variant_select: document.querySelector("[data-product-form] wdn-variant-select"),
      add_to_cart: document.querySelector("button[name='add']"),
      bulk_wrapper: document.querySelector("[data-bulk-quantity-wrapper]"),
      restock_message: document.querySelector("[data-restock-week]"),

      real_form: document.querySelector("[data-product-signup='real'] form"),
      real_variantInput: document.querySelector("[data-product-signup='real'] input[name='variant']"),
      real_email: document.querySelector("[data-product-signup='real'] input[type='email']"),
      real_checkbox: document.querySelector("[data-product-signup='real'] input[type='checkbox']"),
      real_submit: document.querySelector("[data-product-signup='real'] button"),

      dummy_container: document.querySelector("wdn-product-page [data-product-signup='dummy']"),
      dummy_description: document.querySelector("[data-product-signup='dummy'] [data-modal-description]"),
      dummy_submit: document.querySelector("[data-signup-button]"),
      dummy_email: document.querySelector("[data-product-signup='dummy'] input[type='email']"),
      dummy_checkbox: document.querySelector("[data-product-signup='dummy'] input[type='checkbox']"),
    };

    // Controls visibility of the container
    containerVisible = function (isVisible) {
      if (isVisible) {
        nodes.dummy_container.classList.remove("hidden");
        nodes.dummy_submit.classList.remove("hidden");
        nodes.add_to_cart.classList.add("hidden");
        return;
      }
      nodes.dummy_container.classList.add("hidden");
      nodes.dummy_submit.classList.add("hidden");
      nodes.add_to_cart.classList.remove("hidden");
    };

    // Used for updating variant ID on the hidden input
    setVariantInputValue = function (newValue) {
      if (!nodes.real_variantInput) return;
      nodes.real_variantInput.setAttribute("value", newValue);
    };

    // Changes form text based on product availability
    updateDescription = function () {
      if (!nodes.dummy_description) return;
      // Default text - when variant sold out
      var translation = config.translations.variantSoldOut;

      // Text if product sold out
      if (!config.productAvailable) {
        translation = config.translations.productSoldOut;
      }

      nodes.dummy_description.innerHTML = translation;
    };

    // Updates 'Expected delivery week X' message
    updateRestockMessage = function () {
      if (!nodes.restock_message) return;
      var newMessage = "";

      // Get message from the dump
      if (config.restock.hasOwnProperty(_selectedVariant.id)) {
        newMessage = config.restock[_selectedVariant.id];
      }

      // Update container
      nodes.restock_message.innerHTML = newMessage;
    };

    // Fires when variant is changed
    onVariantChange = function (e) {
      if (e.detail !== nodes.variant_select) return;
      var selectedVariant = nodes.variant_select.selectedVariant;
      if (!selectedVariant) return;
      _selectedVariant = selectedVariant;
      var isVariantDiscontinued = variantDiscontinued();

      containerVisible(!selectedVariant.available && !isVariantDiscontinued);
      handleBulkVisibility();
      setVariantInputValue(selectedVariant.id);
      updateRestockMessage();
    };

    onDummyCheckboxChange = function () {
      // Reflect change on the real checkbox
      nodes.real_checkbox.checked = nodes.dummy_checkbox.checked;
    };

    onDummyEmailKeyup = function () {
      // Reflect change on the real email input
      nodes.real_email.value = nodes.dummy_email.value;
      inputError(nodes.dummy_email.value === "");
    };

    inputError = function (hasError) {
      if (hasError) {
        nodes.dummy_email.classList.add("input--error");
        return;
      }

      nodes.dummy_email.classList.remove("input--error");
    };

    onDummySubmit = function () {
      // If required fields not filled - raise error
      var formValid = nodes.real_form.checkValidity();
      inputError(!formValid);
      if (!formValid) return;

      nodes.real_submit.click();
    };

    onFormStatusEvent = function (e) {
      // Reflect form request status to dummy container
      nodes.dummy_container.setAttribute("data-call-status", e.detail);
    };

    // Event listeners
    bind = function () {
      document.body.addEventListener("variant:selected", onVariantChange);

      // Listen for 'real' events
      nodes.real_form.addEventListener("status:updated", onFormStatusEvent);

      // Listen for dummy events
      nodes.dummy_checkbox.addEventListener("change", onDummyCheckboxChange);
      nodes.dummy_email.addEventListener("keyup", onDummyEmailKeyup);
      nodes.dummy_submit.addEventListener("click", onDummySubmit);
    };

    var setInitialState = function () {
      // Assign initial variant id
      if (config.selectedVariant) {
        _selectedVariant = config.selectedVariant;
      }

      var isVariantDiscontinued = variantDiscontinued();

      if (isVariantDiscontinued) {
        containerVisible(false);
        handleBulkVisibility();
        return;
      }

      if (!config.productAvailable || !config.variantAvailable) {
        containerVisible(true);
      }

      handleBulkVisibility();
    };

    var handleBulkVisibility = function () {
      var isVariantDiscontinued = variantDiscontinued();
      var variantAvailable = _selectedVariant ? _selectedVariant.available : true;
      var bulkHidden = true;

      if (config.productAvailable) {
        if (variantAvailable) {
          bulkHidden = false;
        } else if (isVariantDiscontinued) {
          bulkHidden = true;
        }
      }

      if (bulkHidden) {
        nodes.bulk_wrapper.classList.add("hidden");
      } else {
        nodes.bulk_wrapper.classList.remove("hidden");
      }
    };

    // Returns true/false
    var variantDiscontinued = function () {
      if (!_selectedVariant) {
        if (config.hasDefaultVariant && config.discontinuedVariants.length === 1) return true;
        return false;
      }
      return config.discontinuedVariants.indexOf(_selectedVariant.id) > -1;
    };

    init = function () {
      setInitialState();
      bind();
    };

    // init
    init();

    return {};
  })();
}
